module.exports = __webpack_public_path__ + "static/media/home-black.07d16de1.svg";